// The footer newsletter field is a trigger, not a real signup form: submitting
// it opens the global newsletter modal (rendered by the footer) with the typed
// email pre-filled. The actual signup happens inside that modal.
const init = () => {
  const form = document.getElementById('ContactFooter');
  if (!form) return;

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const modal = document.querySelector('newsletter-modal');
    if (!modal || typeof modal.prefill !== 'function') return;

    const input = form.querySelector('input[type="email"]');
    modal.prefill({ email: input ? input.value.trim() : '' });
    modal.open();
  });
};

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
